var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"close",attrs:{"dark":"","fab":"","small":"","icon":"","color":"black","rounded":""},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }